var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 244,
    viewBox: "0 0 454 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.212 8.17171L241.158 100.842C236.691 114.593 217.268 114.593 212.802 100.842L182.748 8.17171C180.747 1.97477 174.098 -1.42748 167.913 0.597664L145.762 7.8072C139.577 9.81208 136.182 16.4748 138.203 22.6718L168.257 115.342C172.723 129.093 156.999 140.535 145.317 132.05L66.6357 74.7788C61.3808 70.9513 54.0038 72.1258 50.1839 77.3912L36.4809 96.2858C32.661 101.551 33.8332 108.943 39.0881 112.771L117.77 170.042C129.452 178.547 123.449 197.057 109.018 197.057L11.783 197.057C5.27507 197.057 -1.8209e-06 202.343 -1.53586e-06 208.864L-5.16083e-07 232.193C-2.31042e-07 238.714 5.27507 244 11.783 244L442.217 244C448.725 244 454 238.714 454 232.193L454 208.843C454 202.322 448.725 197.037 442.217 197.037L344.982 197.037C330.551 197.037 324.548 178.527 336.23 170.021L414.912 112.75C420.167 108.923 421.339 101.551 417.519 96.2656L403.816 77.371C399.996 72.1056 392.619 70.931 387.364 74.7585L308.683 132.03C297.001 140.535 281.277 129.093 285.743 115.322L315.797 22.6515C317.798 16.4545 314.423 9.79183 308.238 7.78693L286.067 0.577411C279.882 -1.42749 273.233 1.95452 271.232 8.15146L271.212 8.17171Z",
    fill: "#C5F7D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.3b1489c388fe7457c4ec400e53a0b5f9.svg";
export { ForwardRef as ReactComponent };